import { Textarea } from '../../../../components/Textarea';
import { EditorProps } from '../types/editor-props';

/**
 * Multi-line text editor for EditableField.
 * Renders a <Textarea> with the current value, and calls onChange/onBlur as needed.
 * Designed to be used as the default editor for multi-line text fields in the FieldEditor component,
 * but can also be used standalone when a textarea input is sufficient.
 */
export function TextAreaEditor({ id, value, onChange, onBlur }: EditorProps) {
  return (
    <Textarea
      id={id}
      value={value == null ? '' : String(value)}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
      autoFocus
      size='full'
      className='text-sm'
    />
  );
}
